import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrProductData } from '../../../../../../shared/types/modules/pqr';

export const usePqrProductData = (productData?: PqrProductData) => {
    const formik = useFormik({
        initialValues: {
            policy: '',
            bonusValue: '',
            plate: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            policy: productData?.policy || '',
            bonusValue: productData?.bonusValue || '',
            plate: productData?.plate || '',
        });
    }, [productData]);

    return {
        formik,
    };
};
